import Vue from "vue";

const getDefaultState = () => {
	return {
		downloads: {},
	};
};

const state = getDefaultState();

const actions = {
	reset({commit}) {
		commit("RESET");
	},
	download({commit, state}, payload) {
		if (!!state.downloads[payload.uniqueId]) {
			return;
		}
		commit("download", payload);
	},
	cancelDownload({commit, state}, requestId) {
		console.log("cancelDownload", requestId);
		http().cancel(requestId);
		Vue.delete(state.downloads, requestId);
	},
};

const mutations = {
	RESET(state) {
		Object.assign(state, getDefaultState());
	},
	download(state, payload) {
		payload.request = http().unique(payload.uniqueId).get(payload.path, {
			params: {
				uniqueId: payload.uniqueId,
				filename: payload.filename,
			},
			responseType: "blob",
			onDownloadProgress: (progressEvent) => {
				if (!state.downloads[payload.uniqueId]) {
					return;
				}
				Vue.set(state.downloads[payload.uniqueId], "progress", progressEvent);
			},
		}).then(response => {
			Vue.delete(state.downloads[payload.uniqueId], "progress");
			const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement("a");
			link.href = downloadUrl;
			link.setAttribute("download", payload.filename);
			document.body.appendChild(link);
			link.click();
			link.remove();

			setTimeout(() => {
				Vue.delete(state.downloads, payload.uniqueId);
			}, 2000);
		});
		Vue.set(state.downloads, payload.uniqueId, payload);
	},
};

const getters = {
	isDownloading: (state) => {
		return !!Object.values(state.downloads).length;
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
